export default __webpack_public_path__ + "static/media/ordningsvakter.51d47332.jpeg";